import { KeyboardEvent, ChangeEvent } from 'react'

export const handleNumericDecimalInput = (event: KeyboardEvent<HTMLInputElement>)  => {
    const key = event.key;
    const input = event.currentTarget;
    const inputValue = input.value;
    
  
    const isNumber = /[0-9]/.test(key);
    const isDecimal = key === '.' || key === ',';
    const alreadyHasDecimal = inputValue.includes('.') || inputValue.includes(',');
  
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Enter',
    ];

    if (key === "," && !alreadyHasDecimal) {
      event.preventDefault();
  
      const start = input.selectionStart ?? inputValue.length;
      const end = input.selectionEnd ?? inputValue.length;
  
      input.value =
        inputValue.substring(0, start) +
        "." +
        inputValue.substring(end);
  
      input.setSelectionRange(start + 1, start + 1);
      return;
    }
  
    if (
      !isNumber &&
      !(isDecimal && !alreadyHasDecimal) &&
      !allowedControlKeys.includes(key)
    ) {
      event.preventDefault();
    }
  }

  // CASE: user pastes value containing " , " => " . " 
  export const handleNumericDecimalChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    let newValue = value.replace(/,/g, ".");

    newValue = newValue.replace(/[^0-9.]/g, "");

    const parts = newValue.split(".");
    if (parts.length > 2) {
      newValue = parts[0] + "." + parts.slice(1).join("");
    }
  
    event.target.value = newValue;
  };

export const handleNumericIntegerInput = (event: KeyboardEvent<HTMLInputElement>)  => {
    const key = event.key;
  
    const isNumber = /[0-9]/.test(key);
  
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Enter',
    ];
  
    if (
      !isNumber &&
      !allowedControlKeys.includes(key)
    ) {
      event.preventDefault();
    }
  }